import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "app-wrapper",
  "data-testid": "cy-default-layout"
}
const _hoisted_2 = { class: "content-container" }

import { inject } from "vue"

import { MainNavigation, Header } from "@layout/components"
import GlobalLoader from "@layout/components/LoaderGlobal.vue"
import { FILE_PRELOADER_SERVICE_KEY } from "@layout/di/keys"
import { FilePreloaderService } from "@layout/di/services"
import { useAuthStore } from "@auth/store/authStore"
import { PATHS } from "@global/utils/PATHS"
import { useLayoutStore } from "@layout/store/layout"
import Onboarding from "@layout/components/onboarding/Onboarding.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStore()

const filePreloaderService = inject(
  FILE_PRELOADER_SERVICE_KEY
) as FilePreloaderService

const authStore = useAuthStore()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Header), { class: "header" }),
      _createVNode(_unref(MainNavigation)),
      _createElementVNode("div", {
        class: _normalizeClass(["content-wrapper", {
          'content-wrapper--filter-gray':
            !_unref(authStore).isMemberOfOrganization &&
            _ctx.$route.path === _unref(PATHS).home.path,
        }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ])
      ], 2),
      (_unref(authStore).isMemberOfOrganization && _unref(layoutStore).isOnboardingOpen)
        ? (_openBlock(), _createBlock(Onboarding, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_unref(filePreloaderService).visible || _unref(layoutStore).isGlobalLoaderActive)
      ? (_openBlock(), _createBlock(GlobalLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})